<template>
    <div v-if="Object.keys(doughnutTotalsPersonsTypes).length > 0">
        <doughnut-chart id="doughnut-chart-size" :height="height" :chart-data="doughnutTotalsPersonsTypes.chartData" :extra-options="doughnutTotalsPersonsTypes.extraOptions">
        </doughnut-chart>
    </div>

</template>

<script>
const defaultObject = {
    chartData: {
        labels: [],
        datasets: [{
            data: [],
            backgroundColor: [],
        }],
    },
    extraOptions: {
        cutoutPercentage: 45,
        legend: {
            display: true,
            position: 'bottom',
        },
        animation: false,
        transitions: {
            ative: {
                animation:{
                    duration: 0,
                }
            }
        },
        tooltips: {
            mode: 'point',
            callbacks: {
                label: function (tooltipItem, data) { return data.labels[tooltipItem.index] }
            }
        },
    }
}

import DoughnutChart from '@/components/Charts/DoughnutChart';

export default {
    component: 'DoughnutChartIngresso',

    components: {
        DoughnutChart,
    },

    props:{
        height: {
            type: Number,
            default: 250
        },

        hideDoughnut: {
          type: Boolean,
          default: false
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        colors: {
            type: Array,
            default: []
        },

        filteredPersonTypes: {
            type: Array | Object,
            default: [],
        }
    },

    methods:{
        capitalizeFirstLetter(string) { return string.charAt(0).toUpperCase() + string.slice(1); },
    },

    data: () => {
        return {
            defaultChart: defaultObject,
        }
    },

    computed:{
        doughnutTotalsPersonsTypes() {
            if(this.fetchProgress > 0 && this.fetchProgress < 100){
                this.defaultChart = defaultObject
                return this.defaultChart
            }

            else if(this.fetchProgress == 0 || this.fetchProgress == 100){
                let labels = {}
                for (let type in this.filteredPersonTypes) {
                    if (this.filteredPersonTypes[type] > 0) {
                        labels[type] = this.filteredPersonTypes[type]
                    }
                }
                let totalPax = Object.values(labels).reduce((prev, cur) => { return prev + cur }, 0)

                this.defaultChart = {
                    chartData: {
                        labels: Object.keys(labels).sort((curr,prox)=>{return labels[curr] < labels[prox]}).map((label, idx) => {
                            return this.capitalizeFirstLetter(label) + ' :: ' + labels[label] + ' visitantes' + ' (' + (labels[label] * 100 / (totalPax)).toFixed(2).replace('.', ',') + '%)'
                        }),
                        datasets: [{
                            data: Object.values(labels),
                            backgroundColor: this.colors,
                        }],
                    },
                    extraOptions: {
                      cutoutPercentage: this.hideDoughnut?100:defaultObject.extraOptions.cutoutPercentage,
                      legend: {
                            display: true,
                            position: 'left',
                        },
                        animation: false,
                        transitions: {
                            ative: {
                                animation:{
                                    duration: 0,
                                }
                            }
                        },
                        tooltips: {
                            mode: 'point',
                            callbacks: {
                                label: function (tooltipItem, data) { return data.labels[tooltipItem.index] }
                            }
                        },
                    }
                };
                return this.defaultChart;
            }
        },

    },
}
</script>
